import InlineEdit from './InlineEdit';

export type { InlineEditProps } from './InlineEdit';
export default InlineEdit;
